import React, { useState, useEffect, useRef } from "react";
import "./maps.css";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";
import cold_storage from "../../../assets/img/cold_storage.png";
import warehouse from "../../../assets/img/warehouse.png";
import VehicleVan from "../../../assets/img/VehicleVan.png";
import CargoVan from "../../../assets/img/CargoVan.png";
import battery from "../../../assets/img/battery.png";

const { compose, withProps, withStateHandlers } = require("recompose");
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  InfoWindow,
  Marker,
} = require("react-google-maps");

export const MapWithAMarkerClusterer = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyD4kLGqTaZAKFG5o5VmF07___IknPJJ5ns&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `95vh` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withStateHandlers(({ reference }) => ({ map: reference }), {
    onMapMounted: () => (map) => {
    
      return { map };
    },
  }),
  withScriptjs,
  withGoogleMap
)((props) => {
  let companyId = "";
  try {
    const data = JSON.parse(localStorage.getItem("companyInfo"));
    companyId = data.companyId;
  } catch (err) { }
 
 

  function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }
  
  function useMoveMarker(initialValue, { delta = 400, delay = 30 } = {}) {
    let [currentPosition, setCurrentPosition] = useState(initialValue);
    let [currentDeltaPosition, setCurrentDeltaPosition] = useState([0, 0]);
    let [currentDelta, setCurrentDelta] = useState(null);
  
    useInterval(
      () => {
        setCurrentDelta(++currentDelta);
        setCurrentPosition([
          currentPosition[0] + currentDeltaPosition[0],
          currentPosition[1] + currentDeltaPosition[1]
        ]);
      },
      currentDelta !== null && currentDelta !== delta ? delay : null
    );
  
    function setPosition(coordinates) {
      const [latitude, longitude] = coordinates;
      setCurrentDelta(0);
      setCurrentDeltaPosition([
        (latitude - currentPosition[0]) / delta,
        (longitude - currentPosition[1]) / delta
      ]);
    }
  
    return [currentPosition, setPosition,currentDelta];
  }

  return (
    <GoogleMap
      ref={props.onMapMounted}
      zoom={props.zoom}
      defaultCenter={{
        lat: props.defaultCenter.lat,
        lng: props.defaultCenter.lng,
      }}
      mapTypeControl={true}
      center={{ lat: props.center.lat, lng: props.center.lng }}
    >
      <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}>
        
        {props.markers.map((marker) => {

          let displayIcon;
          if (marker.type === "warehouse"){
          displayIcon = warehouse;
          } else {
          displayIcon = CargoVan;
          }
          let arrowColor = "#03ABCE ";

          return (
            <Marker
              key={marker._id}
              position={{lat: marker.lat, lng: marker.lng}}
              onClick={() =>
                props.onVehicleClick({
                  value: marker._id,
                  label: marker.imei,
                })
              }
              options={{
                icon: displayIcon
              }}
            >
              <InfoWindow
                options={{
                  // "backgroundColor": '#000000',
                  disableAutoPan: true,
                }}
              >
                {
                  !props.isColdStorage &&
                 
          
                    <div className="info-bubble">
                      <span>
                        <span className="info-map">
                          <span>{marker.thingName || marker.name || "N/A"}</span>
                        </span>
                        <br />
                        <span className="info-map">
                          
                              <span>
                                Temp:{" "}
                                {marker.temperature || marker.temperature === 0
                                  ? marker.temperature
                                  : "N/A"}
                              </span>
                        </span>
                        <br />
                      
                      </span>
                    </div>
        }
              </InfoWindow>
            </Marker>
          );
        })}
      </MarkerClusterer>
      

      
    </GoogleMap>
  );
});
